import React from 'react';
import { useBuilderLabels } from '../context/BuilderLocaleContext';

export default function BuilderMobileNav({ activeTab, onChange }) {
  const t = useBuilderLabels();
  const tabs = [
    { id: 'configure', label: t('configure') },
    { id: 'preview', label: t('preview') },
    { id: 'embed', label: t('embed') },
  ];

  return (
    <nav className="lg:hidden flex border-b border-slate-200 bg-white">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={`flex-1 py-3 text-sm font-semibold border-b-2 transition-colors ${
            activeTab === tab.id
              ? 'border-brand-600 text-brand-700'
              : 'border-transparent text-slate-500'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
